<template>
	<div class="nav">
		<v-btn small elevation="0" color="transparent" class="mr-2 white--text">
			Productos
			<v-icon>
				mdi-chevron-down
			</v-icon>
		</v-btn>

		<v-btn
			elevation="0"
			small
			color="transparent"
			class="mr-2 white--text"
			v-if="$route.name != 'Login'"
			@click="$router.push({ name: 'Login' })"
		>
			Iniciar sesión
		</v-btn>
	</div>
</template>

<script>
export default {
	name: "NavBar",

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.nav {
	position: absolute;
	left: 0;
	top: 90px;
	height: 40px;
	width: 100%;
	width: 100%;
	color: #fff;
	display: flex;
	padding: 0 100px;
	align-items: center;
	justify-content: space-between;
	background-color: #005cb9;
	border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
